module.exports = __webpack_public_path__ + "img/close.0bd36306.svg";